<template>
    <div class="">
        <div class="">
            <img
                class="ic-checkbox"
                src="@/assets/icon/ic-checkbox-active.svg"
                v-show="isActive"
                @click="toggleCheckBox()" />
            <img
                class="ic-checkbox"
                src="@/assets/icon/ic-checkbox-inactive.svg"
                v-show="!isActive"
                @click="toggleCheckBox()" />
        </div>
        <!-- <label class="bi-cb-lbl">{{textLbl}}</label> -->
    </div>
</template>
<script>
export default {
    name: "CheckBox",
    props: {
        //v-model
        value: Boolean,
        //props
        textLbl: String
    },
    data: function () {
        return {
            isActive: this.value
        };
    },
    methods: {
        toggleCheckBox: function () {
            this.isActive = !this.isActive;
            this.$emit('update:check', this.isActive);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./baseinput.scss";

.ic-checkbox {
    width: 28px;
    height: 28px;
}
</style>
